import HeroAbout from "@/components/common/HeroAbout";
import Container from "@/components/layout/Container";

const AboutLocation = () => {
  return (
    <Container>
      <HeroAbout />

      <div className="w-full px-10 wide:px-0 py-[40px]">
        <div className="mb-12 overflow-hidden shadow-lg rounded-2xl">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3165.2819767002275!2d127.0275222!3d37.5012671!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca15869a6610b%3A0x6c12eb9939d77415!2z7ISc7Jq47Yq567OE7IucIOqwleuCqOq1rCDrtInsnYDsgqzroZwxOOq4uCA4NA!5e0!3m2!1sko!2skr!4v1766045752267!5m2!1sko!2skr"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="스탠다드네트웍스 위치"
          />
        </div>

        {/* information */}
        <div className="py-[2rem]">
          <div className="flex flex-col gap-6 pb-8 border-b md:flex-row md:items-top md:justify-between border-gray-2">
            <h2 className="text-[2.8rem] font-bold">스탠다드 네트웍스</h2>
            <div className="space-y-2">
              <p className="text-[1.8rem] text-gray-7">
                <span className="mr-2 align-middle material-icons-round text-navy">
                  location_on
                </span>
                서울시 강남구 봉은사로 18길 84 3층
              </p>
              <p className="text-[1.8rem] text-gray-7">
                <span className="mr-2 align-middle material-icons-round text-navy">call</span>
                문의 : 015-8504-0005
              </p>
            </div>
          </div>

          <div className="pt-8">
            <p className="text-[1.6rem] text-gray-6 leading-[1.8]">
              (주)스탠다드 네트웍스는 국내외 주요 IT협력업체와 협력하여 서버, 스토리지, 백업,
              네트워크 등 각종 시스템을
              <br />
              다양한 사업분야 전반의 정보 시스템 인프라 구축 사업에 제공하고 있습니다.
            </p>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default AboutLocation;
